export const isValidValue = val => {
  return val !== undefined && val !== null
}

export const isValidNumber = val => {
  return val !== undefined && val !== null && !isNaN(val)
}
